import * as React from "react";
import { Question } from "../types";

interface StoreProps {
  question?: Question | null;
}

interface OwnState {
  submitDisabled: boolean;
}

type Props = StoreProps;

class Resolve extends React.PureComponent<Props, OwnState> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      submitDisabled: true
    };
  }

  public render() {
    return (
      <>
        <div className="question">
          <div className="resolve">
            <div className="mb-20">Please take immediate action.</div>
            {this.props.question &&
              this.props.question.SelectedAnswer &&
              this.props.question.SelectedAnswer.Resolve && (
                <div>{this.props.question.SelectedAnswer.Resolve}</div>
              )}
          </div>
        </div>
      </>
    );
  }
}

export default Resolve;
